<template>
  <div id="box">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="title" v-if="consentInfo.isLoading == false" />
        <p
          v-html="description"
          class="description"
          v-if="consentInfo.isLoading == false"
        />
        <p
          v-html="$t('consent.processing')"
          class="description"
          v-if="consentInfo.isLoading == true"
        />
        <p
          v-html="subtitle"
          class="subtitle"
          v-if="consentInfo.isLoading == false"
        />
        <div
          class="expandWrapper dataLoading"
          v-if="consentInfo.isLoading == true"
        >
          <img
            v-svg-inline
            class="img loading"
            src="../assets/imgs/loadingWhite.svg"
            alt="loading"
            v-if="consentInfo.isLoading == true"
          />
        </div>
        <ul class="expandWrapper scopes" v-if="consentInfo.isLoading == false">
          <Scope :iconType="'openid'" />
          <Scope
            :iconType="'verification'"
            v-if="consentInfo.scopes.verification"
          />
          <Scope :iconType="'signing'" v-if="consentInfo.scopes.signing" />
          <Scope :iconType="'mynumber'" v-if="consentInfo.scopes.mynumber" />
          <Scope :iconType="'card'" v-if="consentInfo.scopes.card" />
          <Scope :iconType="'jpki'" v-if="consentInfo.scopes.jpki" />
          <Scope :iconType="'pittari'" v-if="consentInfo.scopes.pittari" />
          <Scope :iconType="'vc'" v-if="consentInfo.scopes.vc" />
          <Scope :iconType="'vp'" v-if="consentInfo.scopes.vp" />
          <Scope :iconType="'vc_issuer'" v-if="consentInfo.scopes.vc_issuer" />
          <Scope
            :iconType="'sp_messages'"
            v-if="consentInfo.scopes.sp_messages"
          />
          <Scope :iconType="'serial'" v-if="consentInfo.scopes.serial" />
          <Scope :iconType="'cardinput'" v-if="consentInfo.scopes.cardinput" />
        </ul>
      </div>
      <div class="wrapper">
        <CustomButton
          v-if="consentInfo.isLoading == false"
          :isSingle="false"
          :buttonType="'accent'"
          :customButtonTxt="$t('customButton.cancel')"
          @submit="cancel"
        />
        <CustomButton
          v-if="consentInfo.isLoading == false"
          :isSingle="false"
          :buttonType="'primary'"
          :customButtonTxt="$t('customButton.confirm')"
          @submit="accept"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
import Scope from "../components/scope.vue";

export default {
  name: "ConfirmConsent",
  components: {
    CustomButton,
    Scope,
  },
  props: {
    consentInfo: {
      type: Object,
    },
  },
  computed: {
    title() {
      return this.$t("consent.title", { service: this.consentInfo.clientName });
    },
    subtitle() {
      return this.$t("consent.subtitle", {
        service: this.consentInfo.clientName,
      });
    },
    description() {
      const privacyTXT = this.getURL(
        this.consentInfo.privacyURL,
        this.$t("common.privacy")
      );
      var termsTXT = this.getURL(
        this.consentInfo.termsURL,
        this.$t("common.terms")
      );
      var andTXT = this.$t("common.and");
      if (this.consentInfo.termsURL == "") {
        andTXT = "";
        termsTXT = "";
      }
      return this.$t("consent.description", {
        service: this.consentInfo.clientName,
        privacy: privacyTXT,
        and: andTXT,
        terms: termsTXT,
      });
    },
  },
  methods: {
    getURL(url, txt) {
      return `<a class="consentLink" style="color: #33CEAA" href="${url}" target="_blank" aria-label="${txt}" rel="noopener">${txt}</a>`;
    },
    cancel() {
      this.$emit("cancel");
    },
    accept() {
      this.$emit("accept");
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper.scopes
    li.scope
      &:last-child
        margin-bottom: 0px !important
  h1
    +lh(14)
  .description
    word-break: break-all
  .expandWrapper.dataLoading
    +flex()
  .wrapper
    margin-top: 12px
    +flex(space-between, center, row)
</style>
